import { PropTypes } from 'prop-types';
import { downloadFileFromS3 } from '@/component/common/FileUploaded';
import AttachFileThumbnail from '@/component/common/AttachFileThumbnail/components/AttachFileThumbnail';

function EmailOtherAttachment({
    file,
    detailTicket,
    thumbnailSize,
    setIsShowPopupLogout,
    setOpenFileOption,
    setOpenOption
}) {
    if (!file) return null;

    let tempFile = { type: 1, ...file };
    const attachFile = detailTicket?.attachFiles?.find(attach => {
        const attachFileUrl = attach?.fileInfo?.fileUrl || attach?.s3Path;
        return attachFileUrl === file?.fileUrl;
    });
    const handleOpenFile = () => {
        downloadFileFromS3(tempFile, detailTicket, false, false, '', setIsShowPopupLogout);
    };

    return (
        <li className="justify-content-center" style={{ marginBottom: 0 }}>
            <div className="display-thumb">
                <AttachFileThumbnail
                    fileName={file.fileName}
                    fileSize={file.fileSize}
                    size={thumbnailSize}
                    onClickFile={handleOpenFile}
                    onClickMore={
                        attachFile
                            ? e => {
                                  setOpenFileOption?.(attachFile);
                                  setOpenOption?.(e.currentTarget);
                              }
                            : undefined
                    }
                />
            </div>
        </li>
    );
}

EmailOtherAttachment.propTypes = {
    file: PropTypes.any,
    detailTicket: PropTypes.any,
    thumbnailSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setIsShowPopupLogout: PropTypes.func,
    setOpenFileOption: PropTypes.func,
    setOpenOption: PropTypes.func
};

export default EmailOtherAttachment;
